<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { hasAccess } from '@/common/utils'
import { getTimes, getStyle, forEachTree } from '@/common/utils'
import { SupplementaryContractDialog } from '@/components/widgets'
import PhotographicWorksDetail from '../photographic-works-detail/view.vue'
import moment from 'moment'
import { shiQuanConfig } from '@/common/app.config'
import decamelize from 'decamelize-keys-deep'
import Cent2 from '../../review/cent2.vue'

// 上传多图
import uploadImageArr from "@/components/newUp/uploadImagesType.vue"

export default {
    components: { WSupplementaryContractDialog: SupplementaryContractDialog, PhotographicWorksDetail ,Cent2, uploadImageArr },
    props:{
        tabsnum:Number,
        value:Array
    },
    data() {
        return {
            up1:{
                type:['image/png','image/jpeg'],
                size:10
            },
            addForm: {
                zipName: '狮圈儿作品变现邀稿模板 - 1.zip',
                zipUrl: 'https://res.shiquaner.zookingsoft.com/d29510d65c6afaad7f73c9883934f794.zip',
				imgs:['https://res.shiquaner.zookingsoft.com/516ff2fed55f84b80c6bcedf395f5a63.png'],
				filse:[]
            },
            hasAccess,
            filterDrawer: false,
            filter: {},
            list: {},

            currentPage: 1,
            pageSize: 50,
            total: 0,
            loading: false,
            collapseName: '1',
            showInviteDialog: false,
            range: [],
            showTemplDialog: false,
            inviteDrawer: false,
            inviteesStatus: {
                0: '邀约状态',
                1: '邀约中',
                2: '已交稿',
                '-1': '放弃交稿'
            },
            timer: null,

            // 设置等级
            currentSetGrade: {},
            gradeDialog: false,
            classifyList: [],

            // 邀搞
            currentInvite: {},
            currentBusiness: '',
            businessList: [],
            currentProjectClassify: '',
            projectClassifyList: [],
            template: [],
            currentTemplate: {},
            // 邀约详情
            inviteDrawerInfo: {},
            examineStep: {
				0: '视觉审核',
				1: '稿件检查',
				2: '价格确认',
				3: '价格审批',
			},
            active: 0,
            activeName:'first',
            dialogVisible:false,
            config_data:[
                {
                    loading:false
                },
                {
                    loading:false
                },
                {
                    loading:false
                },
                {
                    loading:false
                }
            ],
            cent_list:[],//交稿文件列表
            tmpList: [
                { 
                    img: 'https://res.shiquaner.zookingsoft.com/516ff2fed55f84b80c6bcedf395f5a63.png',
                    tmp_url: 'https://res.shiquaner.zookingsoft.com/d29510d65c6afaad7f73c9883934f794.zip' ,
                    tmp_title: '狮圈儿作品变现邀稿模板 - 1'
                },
                { 
                    img: 'https://res.shiquaner.zookingsoft.com/965046d0721b3c1f29da7b1db8940014.png',
                    tmp_url: 'https://res.shiquaner.zookingsoft.com/d3ee91c78065b4e7109ce7b74218f211.zip',
                    tmp_title: '狮圈儿作品变现邀稿模板 - 三屏'
                 },
                { img: 'https://res.shiquaner.zookingsoft.com/b05fc38747ac6be797359ec558d1f97c.png' },
            ],
            is_show:false,
            online_val:{},
            work_list:[],
            picUrls_list:[],
            remark:'',
            replace_type:'',
            standard_pic:'',//模板图片
            template_url:'',//模板zip包url
            template_name:'',//模板名称
            check_arr:[],
            is_show_top:false,
            copywriting:''
        };
    },
    watch:{
        tabsnum(val){
            this.currentPage = 1
            this.getWorkList()
            switch(val)
            {
                case 1:
                    this.copywriting = '加入分发备邀库'
                    break;
                case 2:
                    this.copywriting = '入库'
                    break;
                case 3:
                    this.copywriting = '上线'
                    break;
                case 4:
                    this.copywriting = '下线'
                    break;
                default:
                    break
            }
        },
        value(){
            this.navs = this.value;
        }
    },
    methods: {
        onCopy () {
            this.$message.success('复制成功')
        },
        getValue(val){
            if(val) {
                return val
            } else{
                return "--"
            }
        },
        replace_package(file){
            let _this = this
            console.log(file,'file')
            _this.replace_type = file.file.type
            let app_secret = '1Q61s1iP8I376GyMTdsjOzd4hcLpZ4SG';
			let open_id = 7;
			let times = (Date.parse(new Date()) / 1000);
			let arr = [
				1003,
				app_secret,
				open_id,
				times
			];
            // 通过 FormData 对象上传文件
			var formData = new FormData();
			formData.append("file", file.file);
			formData.append('app_id', 1003);
			formData.append('sign', this.MD5(encodeURIComponent(arr.sort())))
			formData.append('user', open_id)
			formData.append('relation_type', 'activity')
			formData.append('timestamp', times)

			this.axios.post(window.file_upload_baseURL, formData).then(function (response) {
                
                // if(_this.replace_type == 'application/zip'){
                //     console.log('zip')
                //     let tmpList = JSON.parse(JSON.stringify(_this.tmpList))
                //     tmpList[_this.active].tmp_url = response.data.data.url ,
                //     tmpList[_this.active].tmp_title = response.data.data.file_name
                //     _this.tmpList = tmpList
                //     _this.addForm.zipUrl = response.data.data.url
                //     _this.addForm.zipName = response.data.data.file_name
                //     // _this.template_url = response.data.data.url
                //     // _this.template_name = response.data.data.file_name
                //     console.log(_this.addForm,'this.addForm')
                // }else{
                    console.log('img')
                    let tmpList = JSON.parse(JSON.stringify(_this.tmpList))
                    tmpList[_this.active].img = response.data.data.url ,
                    _this.tmpList = tmpList
                    _this.addForm.imgs = response.data.data.url
                    // _this.standard_pic = response.data.data.url
                //      console.log(_this.addForm,'this.addForm')
                // }
                

				console.log(response,'response')
			}).catch(function (error) {
				console.log(error);
			});
        },
        replace_package_zip(file){
            let _this = this
            console.log(file,'file')
            _this.replace_type = file.file.type
            let app_secret = '1Q61s1iP8I376GyMTdsjOzd4hcLpZ4SG';
			let open_id = 7;
			let times = (Date.parse(new Date()) / 1000);
			let arr = [
				1003,
				app_secret,
				open_id,
				times
			];
            // 通过 FormData 对象上传文件
			var formData = new FormData();
			formData.append("file", file.file);
			formData.append('app_id', 1003);
			formData.append('sign', this.MD5(encodeURIComponent(arr.sort())))
			formData.append('user', open_id)
			formData.append('relation_type', 'activity')
			formData.append('timestamp', times)

			this.axios.post(window.file_upload_baseURL, formData).then(function (response) {
                
                // if(_this.replace_type == 'application/zip'){
                    console.log('zip')
                    let tmpList = JSON.parse(JSON.stringify(_this.tmpList))
                    tmpList[_this.active].tmp_url = response.data.data.url ,
                    tmpList[_this.active].tmp_title = response.data.data.file_name
                    _this.tmpList = tmpList
                    _this.addForm.zipUrl = response.data.data.url
                    _this.addForm.zipName = response.data.data.file_name
                    // _this.template_url = response.data.data.url
                    // _this.template_name = response.data.data.file_name
                //     console.log(_this.addForm,'this.addForm')
                // }else{
                //     console.log('img')
                //     let tmpList = JSON.parse(JSON.stringify(_this.tmpList))
                //     tmpList[_this.active].img = response.data.data.url ,
                //     _this.tmpList = tmpList
                //     _this.addForm.imgs = response.data.data.url
                //     // _this.standard_pic = response.data.data.url
                //      console.log(_this.addForm,'this.addForm')
                // }
                

				console.log(response,'response')
			}).catch(function (error) {
				console.log(error);
			});
        },
        add_check(){
            let picUrls_list = JSON.parse(JSON.stringify(this.picUrls_list))
            picUrls_list.forEach(val=>{
                val.check = true
            })
            this.picUrls_list = picUrls_list
            this.check_arr = []
            this.picUrls_list.forEach((val,index)=>{
                if(val.check){
                    this.check_arr.push(val)
                }else{
                    this.check_arr.splice(index,1)
                }
            })
        },
        set_img_index(index){
            let picUrls_list = JSON.parse(JSON.stringify(this.picUrls_list))
            picUrls_list[index].check = !picUrls_list[index].check
            this.picUrls_list = picUrls_list
            
            this.check_arr = []
            this.picUrls_list.forEach((val,index)=>{
                if(val.check){
                    this.check_arr.push(val)
                }else{
                    this.check_arr.splice(index,1)
                }
            })
        },
        handleClose(){
            this.is_show = false
        },
        open_offline(val){
            this.is_show = true
            this.online_val = val
        },
        open_online(val){
            this.is_show = true
            this.online_val = val
        },
        online(val){
            if(this.tabsnum==3){
                var url_name = 'channel_offlineWork'
            }else{
                var url_name = 'channel_onlineWork'
            }
            this.api[url_name]({channel_id:val.channelId,work_id:val.workId}).then((res)=>{
                console.log(res,'ddd')
                if(res){
                    this.is_show = false
                    this.$message.success('操作成功')
                    this.$emit('tabsChange2',this.tabsnum)
                    this.currentPage = 1
                    this.getWorkList()

                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        backtop(){
            this.$refs.scrollDom.scrollTop = 0;
        },
        download(face_url,face_name){
            fetch(face_url).then(res => res.blob()).then(blob => {
				const a = document.createElement('a');
				document.body.appendChild(a)
				a.style.display = 'none'
				// 使用获取到的blob对象创建的url
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				// 指定下载的文件名
				a.download = face_name;
				a.click();
				document.body.removeChild(a)
				// 移除blob对象的url
				window.URL.revokeObjectURL(url);
			});
        },
        handleClose_contract(){
            this.dialogVisible = false
        },
        open_contract(){
            this.dialogVisible = true
        },  
        handleClick_tab(){
            console.log(this.inviteDrawerInfo)
            if(this.activeName == 'second'){
                this.api.channel_fileRecords({channel_id:this.inviteDrawerInfo.channelId}).then((res)=>{
                    this.cent_list = res.data
                    this.cent_list.forEach((val,index)=>{
                        val.preview_pic=JSON.parse(val.preview_pic)
                        val.file_info=JSON.parse(val.file_info)
                    })
                    console.log(this.cent_list,'this.cent_list')
                })
            }
        },
        init() {
            this.getWorkList()
            this.getWorkClassify()
            this.getProjectclassifyList()
            this.getProjectBusiness()
            this.getProjecttemplate()
        },
        setGrade(item) {
            this.currentSetGrade = item
            this.gradeDialog = true
        },
        zipInfo(v1, v2) {
            this.addForm.zipName = v1
            this.addForm.zipUrl = v2
        },
        async getWorkList(reload) {
            if(this.config_data[this.tabsnum-1].loading) return

            try {
                this.config_data[this.tabsnum-1].loading = true
                if(reload) {
                    this.currentPage = 1
                }

                let classify1 = new Set(), classify2 = new Set(), classify3 = new Set()

                if(this.filter.classify) {
                    this.filter.classify.forEach(item => {
                        classify1.add(item[0])
                        classify2.add(item[1])
                        classify3.add(item[2])
                    })
                }

                let filter = JSON.parse(JSON.stringify(this.filter))
                delete filter.classify

                let data = await this.api.getWorkList(Object.assign(
                    {
                        classify_1: [...classify1].join(','),
                        classify_2: [...classify2].join(','),
                        classify_3: [...classify3].join(','),
                        page: this.currentPage,
                        limit: this.pageSize,
                        createTimeStart: this.range[0] ? moment(this.range[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
                        createTimeEnd: this.range[0] ? moment(this.range[1]).format('YYYY-MM-DD 23:59:59') : undefined,
                        isJoinStore: 1,
                        type:this.tabsnum
                    },
                    filter
                ))

                // if(this.currentPage === 1) {
                //     this.list = {}
                // }

                // data.data.forEach(item => {
                //     const itemTime = moment(item.createTime).format('YYYY-MM-DD')

                //     try {
                //         item.labels = JSON.parse(item.labels)
                //     } catch (error) {
                //         item.labels = []
                //     }
                //     if(this.list[itemTime]) {
                //         this.list[itemTime].push(item)
                //     }else {
                //         this.list[itemTime] = [item]
                //     }
                // })
                
                //作品列表改成平铺显示
                data.data.forEach(item => {
                    try {
                        item.labels = JSON.parse(item.labels)
                    } catch (error) {
                        item.labels = []
                    }
                })

                if(this.currentPage === 1) {
                    this.work_list = []
                }

                this.work_list.push(...data.data)


                console.log(this.work_list,'list')


                let { total } = data
                this.total = total

                this.currentPage++

                if(this.tabsnum==1){
                    this.copywriting = '加入分发备邀库'
                }

            } catch (error) {
                throw new Error(error)
            } finally {
              this.config_data[this.tabsnum-1].loading = false
            }
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = {}
            this.range = []
            this.searchClick()
        },
        searchClick() {
            this.getWorkList(true)
            this.closeFilterDrawer()
        },
        getTimes(time) {
            return getTimes(time)
        },
        scroll(event) {
            console.log(event.target.scrollTop,'滚动')

            if(event.target.scrollTop>=500){
                this.is_show_top = true
            }else{
                this.is_show_top = false
            }

            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                const viewHeight = parseFloat(getStyle(event.target, 'height'))
                const scrollTop = event.target.scrollTop
                const scrollHeight = event.target.scrollHeight

                if((viewHeight + scrollTop) >= (scrollHeight - 600)) {
                    this.getWorkList()
                }
            }, 200)
        },
        async getWorkClassify() {
            let data = await this.api.getWorkClassify()

            data = forEachTree(data, (item) => {
                item.value = item.id
                item.label = item.classifyName
                item.children = item.subData
            }, 'subData')

            this.classifyList = data
        },
        preview({ workId }) {
            window.open(`${shiQuanConfig.url}/cont?id=${workId}`)
        },
        inviteClick(item) {
            let da = JSON.parse(JSON.stringify(item.picUrls))
            this.picUrls_list = da.split(',')
            this.picUrls_list = this.picUrls_list.map(val=>{
                return{
                    check:false,
                    img:val
                }
            })
            this.picUrls_list[0].check = true
            this.picUrls_list.forEach((val,index)=>{
                if(val.check){
                    this.check_arr.push(val)
                }else{
                    this.check_arr.splice(index,1)
                }
            })
            this.currentInvite = item
            console.log(this.picUrls_list,'picUrls_list')
            this.showInviteDialog = true
            this.currentTemplate = {}
            this.businessList.forEach(item => {
                if(item.businessName === '邀稿作品') {
                    this.currentBusiness = item.businessType
                }
            })
            this.projectClassifyList.forEach(item => {
                if(item.classifyName === '插画') {
                    this.currentProjectClassify = item.id
                }
            })
            this.template.forEach(item => {
                if(item.templateName === '邀稿投稿统一标准模板') {
                    this.currentTemplate = item
                }
            })
        },
        async getProjectclassifyList() {
            let data = await this.api.getProjectclassifyList()
            this.projectClassifyList = data.data
        },
        async getProjectBusiness() {
            let data = await this.api.getProjectBusiness()
            this.businessList = data
        },
        projectClassifyChange() {
            this.currentTemplate = {}
        },
        openTemplDialog() {
            this.showTemplDialog = true
            this.getProjecttemplate()
        },
        async getProjecttemplate() {
            const data = await this.api.getProjecttemplate({ limit: 5000, classifyId: this.currentProjectClassify })
            this.template = data.data
        },
        editTemplate() {
            if(JSON.stringify(this.currentTemplate) === '{}') {
                this.$message.error('请选择项目模板')
            }else {
                const { href } = this.$router.resolve({
                    path: '/projectManagement/projectclass/edittemplate',
                    query: { row: JSON.stringify(decamelize(this.currentTemplate)) }
                })
                window.open(href)
            }
        },
        templateRowClick(item) {
            
            this.currentTemplate = item
            this.showTemplDialog = false
        },
        async addInvitationProject() {
            if(!this.check_arr.length){
                return this.$message.error('请选择要征收的作品图片')
            }

            if(!this.currentTemplate.id) {
                this.$message.error('请选择项目模板')
                return
            }

            let check_works_arr = []
            this.picUrls_list.forEach((val)=>{
                if(val.check){
                    check_works_arr.push(val.img)
                }
            })

            let obj_da = {
                'standard_pic':this.addForm.imgs || this.tmpList[0].img,
                'choose_pic':check_works_arr,
                'remark':this.remark
            }
        
            let obj = {
                businessType: this.currentBusiness,
                classifyId: this.currentProjectClassify,
                templateProjectId: this.currentTemplate.id,
                workId: this.currentInvite.workId,
                template_url: this.addForm.zipUrl,
                standard_graphic: JSON.stringify(obj_da),
                template_name: this.addForm.zipName,
                tmp_index: this.active
            }

            console.log(obj,'obj')
            await this.api.addInvitationProject({
                // businessType: this.currentBusiness,
                // classifyId: this.currentProjectClassify,
                // templateProjectId: this.currentTemplate.id,
                // workId: this.currentInvite.workId,
                // template_url: this.addForm.zipUrl,
                // standard_graphic: JSON.stringify(this.addForm.imgs) || [this.tmpList[0].img],
                // template_name: this.addForm.zipName,
                // tmp_index: this.active
                businessType: this.currentBusiness,
                classifyId: this.currentProjectClassify,
                templateProjectId: this.currentTemplate.id,
                workId: this.currentInvite.workId,
                template_url: this.addForm.zipUrl,
                standard_graphic: JSON.stringify(obj_da),
                template_name: this.addForm.zipName,
                tmp_index: this.active
            })
            this.$message.success('发起邀约成功')
            this.showInviteDialog = false
            this.currentInvite.inviteesStatus = 1
        },
        previewProject() {
            if(JSON.stringify(this.currentTemplate) === '{}') {
                this.$message.error('请选择项目模板')
            }else {
                const { href } = this.$router.resolve({
                    path: `/projectManagement/projectList/newproject/openproject`,
                    query: { info: JSON.stringify(decamelize(this.currentTemplate)) }
                })
                window.open(href)
            }
        },
        async getInvitationDetail(item) {
            let data = await this.api.getInvitationDetail({ workId: item.workId })

            data.renounceReason = data.renounceReason.split(',')
            this.inviteDrawerInfo = data
            console.log(this.inviteDrawerInfo,'ssss')
            this.inviteDrawer = true
        },
        setLevelSuccess(grade) {
            this.currentSetGrade.recommendLevel = grade
        },
        activeFn (index, img, url, title) {
            this.active = index
            this.addForm.imgs = img
            this.addForm.zipUrl = url
            this.addForm.zipName = title
        },
    },
    created() {
        this.init()
    }
};
</script>
